var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"web-wrapper"},[_c('top'),_vm._v(" "),_c('div',{},[_c('app-main')],1),_vm._v(" "),_c('bottom'),_vm._v(" "),_c('float-window'),_vm._v(" "),_c('contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }